"use client";

import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import {
  buildTrackingPath,
  isNoRecordPath,
  isOnboardingPath,
  trackPage,
} from "@/lib/contentsquare";

/**
 * Loads the Contentsquare main tag and reports a page view on each navigation (see trackPage).
 *
 * The reported page URL is normalized (`/:companyId/dashboard`) and carries only the
 * query params that define the page, so heatmaps are not split per client or per filter.
 * Never-recorded routes (sign in, password reset, checkout link, public TV) are excluded.
 * The onboarding pages are skipped here: they report their own page views, and only once the
 * server says the visitor may be recorded.
 */
export default function ContentsquareInit() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const skipped = isNoRecordPath(pathname) || isOnboardingPath(pathname);
  const search = searchParams?.toString() ?? "";

  useEffect(() => {
    if (skipped) return;
    trackPage(buildTrackingPath(pathname, search));
  }, [pathname, search, skipped]);

  return null;
}
